import { Pipe, PipeTransform } from '@angular/core';
import { IAppConfig } from '@warema/shared/models';

@Pipe({
    name: 'countryISO',
})
export class CountryIsoPipe implements PipeTransform {
    public transform(value: string, settings: IAppConfig): string | undefined {
        return settings.countryConfigMap.get(value)?.ISOCode;
    }
}
